import React from "react";

/**

 * @param {string} text 
 * @param {string} [label="Copy"]
 */
const CopyToClipboardButton = ({ text, label = "Copy" }) => {
  const handleCopy = () => {
    if (!text) {
      alert("Nothing to copy!");
      return;
    }
    navigator.clipboard.writeText(text)
      .then(() => alert("Copied to clipboard!"))
      .catch((err) => console.error("Copy failed:", err));
  };

  return (
    <button type="button" onClick={handleCopy} disabled={!text}>
      {label}
    </button>
  );
};

export default CopyToClipboardButton;
